import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faShieldAlt, faFolderOpen, faHandshake } from '@fortawesome/free-solid-svg-icons'

import './styles.css'
import Header from '../../components/header'
import Footer from '../../components/footer'
// Foto: Kato Blackmore (Unsplash License), unsplash.com/photos/KhF58h0hTbc
import heroPhoto from '../../../assets/img/hero-manutencao.jpg'
import HowItWorks from './HowItWorks'
import StatsSection from './StatsSection'
import ProviderCTA from './ProviderCTA'
import HomeSearch from './HomeSearch'
import { getCounters } from '../../../utils/request'

const formatUpdatedAt = (value) => {
  const date = value && String(value).split('T')[0]
  return date ? date.split('-').reverse().join('/') : null
}

const PROMISES = [
  { icon: faFolderOpen, tone: 'orange', title: 'Tudo em um só lugar', text: 'Sem procurar papel, nota ou conversa antiga no WhatsApp.' },
  { icon: faShieldAlt, tone: 'teal', title: 'Enviado por quem atendeu', text: 'Os registros chegam da empresa responsável pelo atendimento.' },
  { icon: faHandshake, tone: 'violet', title: 'Prova de cuidado', text: 'Mostre que o seu veículo foi bem cuidado na hora de vender.' },
]

export default function Home({ history }) {
  const [indicators, setIndicators] = useState(null)

  useEffect(() => {
    let active = true
    const loadCounters = async () => {
      const res = await getCounters()
      // Na falha a secao de numeros some em vez de mostrar zeros ou "undefined".
      if (active && !res.message && res.payload && res.payload.updatedAt) setIndicators(res.payload)
    }
    loadCounters()
    return () => { active = false }
  }, [])

  const updatedAt = indicators && formatUpdatedAt(indicators.updatedAt)

  return (
    <div className='container-homepage'>
      <Header contained />
      <main>
        <section className='home-hero' aria-labelledby='home-hero-title'>
          {/* Foto so de atmosfera: decorativa, sem texto alternativo. */}
          <img className='home-hero-bg' src={heroPhoto} alt='' aria-hidden='true' />
          <div className='home-container home-hero-inner'>
            <div className='home-hero-copy'>
              <span className='home-eyebrow'>Histórico veicular conectado às oficinas</span>
              <h1 id='home-hero-title'>
                A história do <span className='home-nowrap'>seu veículo,</span>{' '}
                <span className='home-hero-highlight'>sempre com você.</span>
              </h1>
              <p>
                Veja manutenções, ordens de serviço e registros feitos pelas oficinas e autopeças
                onde o seu veículo já foi atendido.
              </p>
            </div>
            <HomeSearch history={history} />
            {/* Hierarquia: buscar (laranja) > criar conta (contorno) > entrar na garagem (link discreto). */}
            <div className='home-hero-cta'>
              <button type='button' className='home-btn home-btn-ghost-light home-hero-signup-btn' onClick={() => history.push('/client/signup')}>
                Criar minha conta
              </button>
              <p className='home-hero-account'>
                Já tem conta?{' '}
                <button type='button' className='home-hero-garage' onClick={() => history.push('/client/login')}>
                  Entrar na minha garagem
                  <FontAwesomeIcon icon={faArrowRight} aria-hidden='true' />
                </button>
              </p>
            </div>
          </div>
        </section>

        <div className='home-container'>
          <ul className='home-promises' aria-label='Por que usar o Sobre Rodas'>
            {PROMISES.map(promise => (
              <li key={promise.title}>
                {/* Marca d'agua do mesmo icone no canto: personalidade sem peso. */}
                <FontAwesomeIcon icon={promise.icon} className={`home-promise-deco home-promise-deco-${promise.tone}`} aria-hidden='true' />
                <span className={`home-icon home-icon-${promise.tone} home-promise-icon`} aria-hidden='true'>
                  <FontAwesomeIcon icon={promise.icon} />
                </span>
                <strong>{promise.title}</strong>
                <span>{promise.text}</span>
              </li>
            ))}
          </ul>

          {indicators && <StatsSection indicators={indicators} updatedAt={updatedAt} />}
          <HowItWorks />
          <ProviderCTA onAccess={() => history.push('/provider/login')} />

          <p className='home-bridge'>
            Uma ponte digital entre <strong>quem cuida do veículo</strong> e <strong>quem confia esse cuidado</strong>.
          </p>
        </div>
      </main>
      <Footer contained />
    </div>
  )
}
